import { File } from "lucide-react";

interface DocumentationItem {
  name: string;
  url: string;
}

interface DocumentationListProps {
  documentation: DocumentationItem[];
  className?: string;
}

export const DocumentationList = ({ documentation, className = "" }: DocumentationListProps) => {
  if (!documentation || documentation.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {documentation.map((doc, index) => (
        <a
          key={index}
          href={doc.url}
          download
          className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-50 mt-2 px-3 py-1 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <File className="h-3 w-3 flex-shrink-0" />
          <span>{doc.name}</span>
        </a>
      ))}
    </div>
  );
};
